import axios from 'axios';
import normalize from 'Utils/normalizer';
import _, { map, omitBy, isEmpty, isNil, omit, toUpper } from 'lodash';

import { errorHandler } from '../utils';
import { getWithExpiry } from 'Helpers/getset-with-expiry';


export const fetchShippingInfo = async (obj) => {
    const url = `${process.env.API_URL}/${process.env.API_VER}/ecom/delivery/ninjavan/rates`;
    const session = getWithExpiry(process.env.APP_SESSION);
    const { accessToken } = session;

    try {
        const response = await axios({
            method: 'POST',
            url: url,
            data: obj,
            headers: { 'Authorization': `Bearer ${accessToken}` }
        });
        
        return response.data;
    }
    catch (err) {
        const { error } = err.response?.data || {};
        if (!isEmpty(error)) {
            const callback = async () => await fetchShippingInfo(obj);
            const { value, code, message, stack } = await errorHandler.response(error, { callback });
            return { error: { value, code, message, stack } };
        }
        else {
            return { error: { message: err.message } };
        }
    }
}
